import dayjs from 'dayjs';

import { PRIORITY_PASS_STATUS_ENUM } from 'services/events/evetns.api.type';

export type PriorityPassFilterType = {
  term: string;
  status: PRIORITY_PASS_STATUS_ENUM;
  pageNumber: number;
  pageSize: number;
};

export const initialFilter: PriorityPassFilterType = {
  term: '',
  status: PRIORITY_PASS_STATUS_ENUM.ALL,
  pageNumber: 1,
  pageSize: 10,
};

export const formatDate = (input: string) => {
  const dateTimeObj = dayjs(input);

  // Get the day, month, year, and time
  const day = dateTimeObj.format('D'); // Day (e.g., 23)
  const month = dateTimeObj.format('MMMM'); // Full month name (e.g., November)
  const year = dateTimeObj.format('YYYY'); // Full year (e.g., 2023)
  const time = dateTimeObj.format('HH:mm'); // 24-hour time (e.g., 12:00)

  // Combine everything into the desired format (without ordinal suffix)
  const formattedDate = `${day} ${month} ${year} ${time}`;

  return formattedDate;
};
